import { render, staticRenderFns } from "./ChatSearch.vue?vue&type=template&id=29779264&"
import script from "./ChatSearch.vue?vue&type=script&lang=js&"
export * from "./ChatSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports